const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCal1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4845_7294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9051 22.5417C35.7188 18.7279 35.7186 12.5447 31.9049 8.73102C28.0911 4.91737 21.9078 4.91748 18.0942 8.73126C14.2805 12.545 14.2806 18.7283 18.0944 22.5419C21.9082 26.3556 28.0915 26.3555 31.9051 22.5417Z",
    fill: "#FDD39E",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9917 0.8290 0.6198)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.891 36.8995L45.863 34.2502C49.2637 33.494 50.1471 37.5677 47.3907 38.5639C45.4959 39.2264 36.9716 42.8666 31.1029 45.0669C26.8816 46.6496 25.6051 46.8612 21.1595 46.6492L14.4013 46.3269L13.3691 49.5235H0.976562L2.5248 42.29C3.35741 38.3999 6.29607 35.0566 10.2743 35.0566L23.5554 35.0262C24.6707 34.9231 31.4348 34.1529 32.5504 34.0499C33.7143 33.9424 34.7521 34.8395 34.8564 36.0434C34.9608 37.2474 34.0075 37.9613 32.9296 38.4281C30.103 39.6519 27.0283 40.7191 24.4491 41.3248M29.3944 15.6368H24.9999V11.2422",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 29.7966C32.8202 29.7966 39.1598 23.4569 39.1598 15.6366C39.1598 7.81621 32.8202 1.47656 24.9998 1.47656C17.1795 1.47656 10.8398 7.81621 10.8398 15.6366C10.8398 23.4569 17.1795 29.7966 24.9998 29.7966Z",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4845_7294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0 0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal1);
export default __webpack_public_path__ + "static/media/cal1.46cc98e75fee262e6078a7d85c8f4ad1.svg";
export { ForwardRef as ReactComponent };